import { gql } from '@apollo/client'

export const GET_LIST_QUESTION_BANK_CATEGORY = gql`
  query findAllQuestionBankCategory($params: QuestionBankCategoryQueryInput = {}) {
    findAllQuestionBankCategory(query: $params) {
      count
      items {
        id
        membershipLevel
        title
        createdAt
        updatedAt
        isLive
        tabIndex
        subject {
          id
          tabName
          slug
          platform {
            id
            title
          }
        }
        order
      }
    }
  }
`

export const GET_ONE_QUESTION_BANK_CATEGORY = gql`
  query findOneQuestionBankCategory($params: String!) {
    findOneQuestionBankCategory(id: $params) {
      id
      membershipLevel
      title
      createdAt
      updatedAt
      isLive
      subject {
        id
        tabName
        slug
        platform {
          id
          title
        }
      }
      order
    }
  }
`

export const CREATE_QUESTION_BANK_CATEGORY = gql`
  mutation createQuestionBankCategory($params: CreateQuestionBankCategoryInput!) {
    createQuestionBankCategory(createQuestionBankCategoryInput: $params) {
      id
    }
  }
`

export const UPDATE_QUESTION_BANK_CATEGORY = gql`
  mutation updateQuestionBankCategory($params: UpdateQuestionBankCategoryInput!) {
    updateQuestionBankCategory(updateQuestionBankCategoryInputFieldName: $params) {
      id
    }
  }
`

export const DELETE_QUESTION_BANK_CATEGORY = gql`
  mutation removeQuestionBankCategory($params: String!) {
    removeQuestionBankCategory(id: $params) {
      affected
    }
  }
`

export const GET_DASHBOARD_QUESTION_BANK_CATEGORY = gql`
  query findDashboardQuestionBankCategory($params: QuestionBankCategoryQueryInput = {}) {
    findAllQuestionBankCategory(query: $params) {
      count
      items {
        id
        title
        membershipLevel
        subject {
          id
          slug
          tabName
        }
        isLive
        order
        tabIndex
        questionBanks {
          id
          title
          isLive
          order
          questionIds
        }
      }
    }
  }
`

export const BULK_UPDATE_QUESTION_BANK_CATEGORY = gql`
  mutation bulkUpdateQuestionBankCategory($params: [BulkUpdateQuestionBankCategoryInput!]!) {
    bulkUpdateQuestionBankCategory(bulkUpdateQuestionBankCategoryInput: $params) {
      id
    }
  }
`
